// extracted by mini-css-extract-plugin
export default {"main_div":"PatientModal_main_div__M8cqD","error_msg":"PatientModal_error_msg__38BqR"};